import { Badge } from 'antd'
import type { CSSProperties } from 'react'

import { ConditionalText } from 'src/components/ConditionalText'

type Props = {
  text?: string
  color?: string | null
  style?: CSSProperties
  className?: string
}

export const BadgeText = ({ text, color, style, className }: Props) => {
  return color ? (
    <Badge color={color} text={text} style={style} className={className} />
  ) : (
    <ConditionalText
      weight={400}
      condition={!!text}
      style={style}
      className={className}
    >
      {text}
    </ConditionalText>
  )
}
